export default {
    getCompany: state => (id) => state.companyList.find(company => company.id === id)
}
